<template>
    <div>
        <div class=" reveal">
            <v-card class="hidden-lg-and-up ma-3"
                    style="box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px; border-radius: 10px">
                <div style="background-color: #fceded">
                    <div style="height: 300px">
                        <img src="../../../../../assets/ib_math.gif"  alt="IVYED Math Class" style="height: 100%; width: 100%" class="pa-4">
                    </div>
                </div>
                <div class="pa-5">
                    <div style="font-size: 19px; font-weight: bold">매 수업 녹화본으로 바로 복습 가능</div>
                    <div class="py-2"></div>
                    <div class="text-left pl-3"><span style="color: #A30717" content="\2713"> &#10004;  </span>
                        수업 중
                        필기없이 수업에만 집중
                    </div>
                    <div class="text-left pl-3"><span style="color: #A30717" content="\2713"> &#10004;  </span> 매
                        수업
                        녹화본으로 언제든 복습 가능
                    </div>
                    <!--                            <div class="text-left"><span style="color: #A30717" content="\2713"> &#10004;  </span> 27/7 질문 가능한 아이비에드</div>-->
                </div>
            </v-card>
            <v-card class="hidden-md-and-down ma-3"
                    style="box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px; border-radius: 10px">
                <div style="background-color: #fceded">
                    <div style="height: 400px; width: 400px;">
                        <img src="../../../../../assets/ib_math.gif" alt="IVYED Math Class" style="height: 100%; width: 100%" class="pa-4">
                    </div>
                </div>
                <div class="pa-5">
                    <div style="font-size: 22px; font-weight: bold">매 수업 녹화본으로 바로 복습 가능</div>
                    <div class="py-2"></div>
                    <div style="font-size: 18px; padding-left: 20px" class="text-left" >
                        <span style="color: #A30717" content="\2713"> &#10004;  </span>
                        수업 중
                        필기없이 수업에만 집중
                    </div>
                    <div class="text-left" style="font-size: 18px;padding-left: 20px"><span style="color: #A30717" content="\2713"> &#10004;  </span>
                        매 수업 녹화본으로 언제든 복습 가능
                    </div>
                </div>
                <!--                            <div class="text-left"><span style="color: #A30717" content="\2713"> &#10004;  </span> 27/7 질문 가능한 아이비에드</div>-->
                <!--                </div>-->
            </v-card>


        </div>

    </div>
</template>

<script>
    export default {
        name: "AboutIvyed7",
        mounted() {
            window.addEventListener("scroll", this.reveal);
        },
        destroyed() {
            window.removeEventListener("scroll", this.reveal);
        },
        methods: {
            reveal() {
                var reveals = document.querySelectorAll(".reveal");

                for (var i = 0; i < reveals.length; i++) {
                    var windowHeight = window.innerHeight;
                    var elementTop = reveals[i].getBoundingClientRect().top;
                    var elementVisible = 150;

                    if (elementTop < windowHeight - elementVisible) {
                        reveals[i].classList.add("active");
                    } else {
                        reveals[i].classList.remove("active");
                    }
                }
            },
        },
    };
</script>

<style>

    body {
        /*background: #42455a;*/
    }

    section {
        /*min-height: 100vh;*/
        /*display: flex;*/
        /*justify-content: center;*/
        /*align-items: center;*/
    }

    .each-title {
        font-size: 21px !important;
        text-align: left !important;
    }

    section:nth-child(1) {
        color: black;
    }

    section:nth-child(2) {
        color: black;
        background: #ffffff !important;
    }

    /* Add more styles for other sections as needed */
    section .container {
        /*margin: 100px;*/
        background-color: #ffffff !important;

    }

    section h1 {
        /*font-size: 3rem;*/
        /*margin: 20px;*/
    }

    section h2 {
        font-size: 40px;
        /*text-align: center;*/
        text-transform: uppercase;
    }

    section .text-container {
        display: flex;
        padding: 20px;
        margin-top: 10px;
    }

    section .text-container .text-box {
        /*margin: 20px;*/
        /*padding: 20px;*/
        /*background: #00c2cb;*/

    }

    section .text-container .text-box h3 {
        font-size: 30px;
        /*text-align: center;*/
        text-transform: uppercase;
        margin-bottom: 10px;
    }

    @media (max-width: 900px) {
        section h1 {
            font-size: 2rem;
            /*text-align: center;*/
        }

        section .text-container {
            flex-direction: column;
        }
    }

    .reveal {
        position: relative;
        transform: translateY(150px);
        opacity: 0;
        transition: 1s all ease;
    }

    .reveal.active {
        transform: translateY(0);
        opacity: 1;
    }
</style>

